module.exports = __webpack_public_path__ + "img/top_cover.6a1e088b.png";